import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { DictionaryService } from './dictionary.service';

@Injectable({
  providedIn: 'root'
})
export class HelperService
{

  constructor(private dictionaryService: DictionaryService) { }

  /**
   * Get all data used for team provider.
   */
  public getTeamProviderDataFromMultipleSources(): Observable<any[]>
  {
    const genders = this.dictionaryService.getCachedGenders();
    const states = this.dictionaryService.getCachedStatesOrProvinces();
    const specialties = this.dictionaryService.getCachedSpecialties();
    return forkJoin([genders, states, specialties]);
  }

  /**
   * Get all data used for member search.
   */
  public getMemberSearchDataFromMultipleSources(): Observable<any[]>
  {
    const genders = this.dictionaryService.getCachedGenders();
    const states = this.dictionaryService.getCachedStatesOrProvinces();
    return forkJoin([genders, states]);
  }

  /**
   * Get all genders, states and countries.
   */
  public getGendersStatesCountriesFromMultipleSources(): Observable<any[]>
  {
    const genders = this.dictionaryService.getCachedGenders();
    const states = this.dictionaryService.getCachedStatesOrProvinces();
    const countries = this.dictionaryService.getCachedCountries();
    return forkJoin([genders, states, countries]);
  }

  /**
   * Get all genders, states, countries and address types.
   */
  public getGendersStatesCountriesAddressTypesFromMultipleSources(): Observable<any[]>
  {
    const genders = this.dictionaryService.getCachedGenders();
    const states = this.dictionaryService.getCachedStatesOrProvinces();
    const countries = this.dictionaryService.getCachedCountries();
    const addressTypes = this.dictionaryService.getCachedAddressTypes();
    return forkJoin([genders, states, countries, addressTypes]);
  }

  public getDemographicsDictionariesFromMultipleSources(): Observable<any[]>
  {
    const educationLevels = this.dictionaryService.getCachedEducationLevels();
    const employmentStatuses = this.dictionaryService.getCachedEmploymentStatuses();
    const maritalStatuses = this.dictionaryService.getCachedMaritalStatuses();
    const religiousAffiliations = this.dictionaryService.getCachedReligiousAffiliations();
    const housingStatuses = this.dictionaryService.getCachedHousingStatuses();
    const veteranStatuses = this.dictionaryService.getCachedVeteranStatuses();

    const namePronouns = this.dictionaryService.getCachedNamePronouns();
    const englishProficiencies = this.dictionaryService.getCachedEnglishProficiencies();
    const interpreterNeedsList = this.dictionaryService.getCachedInterpreterNeeds();
    const sexualOrientations = this.dictionaryService.getCachedSexualOrientations();

    return forkJoin([educationLevels, employmentStatuses, maritalStatuses, religiousAffiliations, housingStatuses,
      veteranStatuses, namePronouns, englishProficiencies, interpreterNeedsList, sexualOrientations]);
  }

  /**
   * Get all states and countries.
   */
  public getStatesCountriesFromMultipleSources(): Observable<any[]>
  {
    const states = this.dictionaryService.getCachedStatesOrProvinces();
    const countries = this.dictionaryService.getCachedCountries();
    return forkJoin([states, countries]);
  }

}
